module.exports = __webpack_public_path__ + "img/support_system_sp_v2.f25cea53.png";